<template>
  <Card :name="config.variableFullName">
    <template v-slot:header>
      <h4 class="card-title">
        {{ config.variableFullName }}
      </h4>
    </template>

    <i
      class="fa "
      :class="[config.icon, getIconColorClass()]"
      style="font-size: 30px"
    ></i>

    <button
      @click="sendValue()"
      :class="[ `btn btn-${config.class}`]"
      class="mb-3 pull-right"
      size="lg"
      >{{ config.text }}</button
    >
  </Card>
</template>

<script>
import emitter from '@/eventBus';
export default {
  props: ["config"],
  data() {
    return {
      status: false,
      topic: ""
    };
  },
  mounted() {},

  watch: {
    config: {
      immediate: true,
      deep: true,
      handler() {
        setTimeout(() => {
          this.status = false;
          
          let variable = this.config.variable;
          if (this.$store.state.selectedDevice.ext_mqtt){
            variable = this.config.variableFullName 
          }

          emitter.off(this.topic + "/sdata");

          this.topic =
            this.config.userId +
            "/" +
            this.config.selectedDevice.dId +
            "/" +
            variable;
          emitter.on(this.topic + "/sdata", this.procesReceivedData);
        }, 300);
      }
    }
  },
  beforeDestroy() {
    emitter.off(this.topic + "/sdata");
  },

  methods: {
    sendValue() {
      this.status = !this.status;
      
      let variable = this.config.variable;  
      if (this.$store.state.selectedDevice.ext_mqtt){
        variable = this.config.variableFullName 
      }
      

      const toSend = {
        topic: this.topic + "/actdata",
        msg: {
          value: this.status
        }
      };

      //console.log(toSend);
      emitter.emit("mqtt-sender", toSend);
    },

    procesReceivedData(data) {
      if (data == null) return;
      try {
        this.status = data.value;
      } catch (error) {
        console.log(error);
      }
    },

    getIconColorClass() {
      if (!this.status) {
        return "text-dark";
      }

      if (this.config.class == "success") {
        return "text-success";
      }
      if (this.config.class == "primary") {
        return "text-primary";
      }
      if (this.config.class == "warning") {
        return "text-warning";
      }
      if (this.config.class == "danger") {
        return "text-danger";
      }
    }
  }
};
</script>
